import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbMultiSelect as ClbMultiSelect_ } from '@celebration/design-system/dist/lib/multi-select';
const events = {
    onClbValueChange: ClbMultiSelect_.events
        .onClbValueChange,
    onClbApply: ClbMultiSelect_.events
        .onClbApply,
    onClbClear: ClbMultiSelect_.events
        .onClbClear,
};
export const ClbMultiSelect = createComponent({
    tagName: ClbMultiSelect_.tagName,
    elementClass: ClbMultiSelect_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map